export default {
      id: "search-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg#search",
      toString: function () {
        return this.url;
      }
    }